
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 17H5a2 2 0 01-2-1.999V10a2 2 0 011.999-2H19a2 2 0 012 1.999V15a2 2 0 01-1.999 2H17.5M17.5 8V4a1 1 0 00-1-1h-9a1 1 0 00-1 1v4","stroke":"#F2F3F5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M7.5 13.5h9a1 1 0 011 1V20a1 1 0 01-1 1h-9a1 1 0 01-1-1v-5.5a1 1 0 011-1z","stroke":"#F2F3F5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    